import {
  getActionHeader,
  getActionIcon,
  getActionTextColor,
} from "../../../../../utils/ecgUtil";
import styles from "./EcgAction.module.css";

type EcgActionProps = {
  severity?: number;
  displayName: string;
  smallIcon?: boolean;
  displayIcon?: boolean;
  colorFont?: boolean;
  displaySeverity?: boolean;
};

const EcgAction = ({
  severity,
  displayName,
  smallIcon,
  displayIcon = true,
  colorFont = false,
  displaySeverity = false,
}: EcgActionProps) => {
  const actionIcon = displayIcon ? (
    <img
      className={
        displaySeverity
          ? styles.iconWithSeverity
          : smallIcon
          ? styles.iconSm
          : styles.iconLg
      }
      src={getActionIcon(severity)}
      alt={getActionHeader(severity)}
    />
  ) : null;

  const actionMessage = (
    <span
      style={{ color: colorFont ? getActionTextColor(severity) : undefined }}
    >
      {displayName}
    </span>
  );

  return (
    <div className="d-flex align-items-center">
      {displaySeverity ? (
        <div>
          <h5
            className={`capitalized ${styles.severityHeader}`}
            style={{ color: getActionTextColor(severity) }}
          >
            {actionIcon} {getActionHeader(severity)}
          </h5>
          {actionMessage}
        </div>
      ) : (
        <div>
          {actionIcon}
          <span className="mx-sm"></span>
          {actionMessage}
        </div>
      )}
    </div>
  );
};

export default EcgAction;
